  <h1 class="table__title" >{{data.title}}</h1>
  
  <h3 style="margin-bottom: 2rem;white-space:pre-wrap; color: black; font-weight: normal;">{{data.description}}</h3>
  


  <ul class="table__control inline-list">
    <li>
      <div>
      <button mat-raised-button color="primary" (click)="onOption1Click()" >{{data.option1}}</button>
      </div>
    </li>
    <li >
      <button mat-raised-button  color="accent" (click)="onOption2Click()" >{{data.option2}}</button>
    </li>
   
  </ul>


  
  